import { useState } from "react";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import Hero from "@/pages/home/components/Hero";
import RankBoard from "@/pages/home/components/RankBoard";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import ReviewSection from "@/pages/home/components/ReviewSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  const [query, setQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");

  return (
    <>
      <SiteNavbar />
      <main>
        <Hero
          onSearch={(value) => {
            setQuery(value);
            setActiveCategory("all");
          }}
        />
        <RankBoard
          query={query}
          onQueryChange={setQuery}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
        <CategoryGrid onSelect={setActiveCategory} />
        <ReviewSection />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}